export const COUNTRIES = [
  { code: 'AF', label: 'Afghanistan', dial: '93', currency: 'AFN' },
  { code: 'AL', label: 'Albania', dial: '355', currency: 'ALL' },
  { code: 'DZ', label: 'Algeria', dial: '213', currency: 'DZD' },
  { code: 'AS', label: 'American Samoa', dial: '1', currency: 'USD' },
  { code: 'AD', label: 'Andorra', dial: '376', currency: 'EUR' },
  { code: 'AO', label: 'Angola', dial: '244', currency: 'AOA' },
  { code: 'AI', label: 'Anguilla', dial: '1', currency: 'XCD' },
  { code: 'AG', label: 'Antigua and Barbuda', dial: '1', currency: 'XCD' },
  { code: 'AR', label: 'Argentina', dial: '54', currency: 'ARS' },
  { code: 'AM', label: 'Armenia', dial: '374', currency: 'AMD' },
  { code: 'AW', label: 'Aruba', dial: '297', currency: 'AWG' },
  { code: 'AU', label: 'Australia', dial: '61', currency: 'AUD' },
  { code: 'AT', label: 'Austria', dial: '43', currency: 'EUR' },
  { code: 'AZ', label: 'Azerbaijan', dial: '994', currency: 'AZN' },
  { code: 'BS', label: 'Bahamas', dial: '1', currency: 'BSD' },
  { code: 'BH', label: 'Bahrain', dial: '973', currency: 'BHD' },
  { code: 'BD', label: 'Bangladesh', dial: '880', currency: 'BDT' },
  { code: 'BB', label: 'Barbados', dial: '1', currency: 'BBD' },
  { code: 'BY', label: 'Belarus', dial: '375', currency: 'BYN' },
  { code: 'BE', label: 'Belgium', dial: '32', currency: 'EUR' },
  { code: 'BZ', label: 'Belize', dial: '501', currency: 'BZD' },
  { code: 'BJ', label: 'Benin', dial: '229', currency: 'XOF' },
  { code: 'BM', label: 'Bermuda', dial: '1', currency: 'BMD' },
  { code: 'BT', label: 'Bhutan', dial: '975', currency: 'BTN' },
  { code: 'BO', label: 'Bolivia', dial: '591', currency: 'BOB' },
  { code: 'BA', label: 'Bosnia and Herzegovina', dial: '387', currency: 'BAM' },
  { code: 'BW', label: 'Botswana', dial: '267', currency: 'BWP' },
  { code: 'BR', label: 'Brazil', dial: '55', currency: 'BRL' },
  { code: 'VG', label: 'British Virgin Islands', dial: '1', currency: 'USD' },
  { code: 'BN', label: 'Brunei', dial: '673', currency: 'BND' },
  { code: 'BG', label: 'Bulgaria', dial: '359', currency: 'BGN' },
  { code: 'BF', label: 'Burkina Faso', dial: '226', currency: 'XOF' },
  { code: 'BI', label: 'Burundi', dial: '257', currency: 'BIF' },
  { code: 'KH', label: 'Cambodia', dial: '855', currency: 'KHR' },
  { code: 'CM', label: 'Cameroon', dial: '237', currency: 'XAF' },
  { code: 'CA', label: 'Canada', dial: '1', currency: 'CAD' },
  { code: 'CV', label: 'Cape Verde', dial: '238', currency: 'CVE' },
  { code: 'KY', label: 'Cayman Islands', dial: '1', currency: 'KYD' },
  { code: 'CF', label: 'Central African Republic', dial: '236', currency: 'XAF' },
  { code: 'TD', label: 'Chad', dial: '235', currency: 'XAF' },
  { code: 'CL', label: 'Chile', dial: '56', currency: 'CLP' },
  { code: 'CN', label: 'China', dial: '86', currency: 'CNY' },
  { code: 'CO', label: 'Colombia', dial: '57', currency: 'COP' },
  { code: 'KM', label: 'Comoros', dial: '269', currency: 'KMF' },
  { code: 'CG', label: 'Congo', dial: '242', currency: 'XAF' },
  { code: 'CD', label: 'Congo (DRC)', dial: '243', currency: 'CDF' },
  { code: 'CK', label: 'Cook Islands', dial: '682', currency: 'NZD' },
  { code: 'CR', label: 'Costa Rica', dial: '506', currency: 'CRC' },
  { code: 'CI', label: "Côte d'Ivoire", dial: '225', currency: 'XOF' },
  { code: 'HR', label: 'Croatia', dial: '385', currency: 'EUR' },
  { code: 'CU', label: 'Cuba', dial: '53', currency: 'CUP' },
  { code: 'CY', label: 'Cyprus', dial: '357', currency: 'EUR' },
  { code: 'CZ', label: 'Czech Republic', dial: '420', currency: 'CZK' },
  { code: 'DK', label: 'Denmark', dial: '45', currency: 'DKK' },
  { code: 'DJ', label: 'Djibouti', dial: '253', currency: 'DJF' },
  { code: 'DM', label: 'Dominica', dial: '1', currency: 'XCD' },
  { code: 'DO', label: 'Dominican Republic', dial: '1', currency: 'DOP' },
  { code: 'EC', label: 'Ecuador', dial: '593', currency: 'USD' },
  { code: 'EG', label: 'Egypt', dial: '20', currency: 'EGP' },
  { code: 'SV', label: 'El Salvador', dial: '503', currency: 'USD' },
  { code: 'GQ', label: 'Equatorial Guinea', dial: '240', currency: 'XAF' },
  { code: 'ER', label: 'Eritrea', dial: '291', currency: 'ERN' },
  { code: 'EE', label: 'Estonia', dial: '372', currency: 'EUR' },
  { code: 'SZ', label: 'Eswatini', dial: '268', currency: 'SZL' },
  { code: 'ET', label: 'Ethiopia', dial: '251', currency: 'ETB' },
  { code: 'FK', label: 'Falkland Islands', dial: '500', currency: 'FKP' },
  { code: 'FO', label: 'Faroe Islands', dial: '298', currency: 'DKK' },
  { code: 'FJ', label: 'Fiji', dial: '679', currency: 'FJD' },
  { code: 'FI', label: 'Finland', dial: '358', currency: 'EUR' },
  { code: 'FR', label: 'France', dial: '33', currency: 'EUR' },
  { code: 'PF', label: 'French Polynesia', dial: '689', currency: 'XPF' },
  { code: 'GA', label: 'Gabon', dial: '241', currency: 'XAF' },
  { code: 'GM', label: 'Gambia', dial: '220', currency: 'GMD' },
  { code: 'GE', label: 'Georgia', dial: '995', currency: 'GEL' },
  { code: 'DE', label: 'Germany', dial: '49', currency: 'EUR' },
  { code: 'GH', label: 'Ghana', dial: '233', currency: 'GHS' },
  { code: 'GI', label: 'Gibraltar', dial: '350', currency: 'GIP' },
  { code: 'GR', label: 'Greece', dial: '30', currency: 'EUR' },
  { code: 'GL', label: 'Greenland', dial: '299', currency: 'DKK' },
  { code: 'GD', label: 'Grenada', dial: '1', currency: 'XCD' },
  { code: 'GU', label: 'Guam', dial: '1', currency: 'USD' },
  { code: 'GT', label: 'Guatemala', dial: '502', currency: 'GTQ' },
  { code: 'GN', label: 'Guinea', dial: '224', currency: 'GNF' },
  { code: 'GW', label: 'Guinea-Bissau', dial: '245', currency: 'XOF' },
  { code: 'GY', label: 'Guyana', dial: '592', currency: 'GYD' },
  { code: 'HT', label: 'Haiti', dial: '509', currency: 'HTG' },
  { code: 'HN', label: 'Honduras', dial: '504', currency: 'HNL' },
  { code: 'HK', label: 'Hong Kong', dial: '852', currency: 'HKD' },
  { code: 'HU', label: 'Hungary', dial: '36', currency: 'HUF' },
  { code: 'IS', label: 'Iceland', dial: '354', currency: 'ISK' },
  { code: 'IN', label: 'India', dial: '91', currency: 'INR' },
  { code: 'ID', label: 'Indonesia', dial: '62', currency: 'IDR' },
  { code: 'IR', label: 'Iran', dial: '98', currency: 'IRR' },
  { code: 'IQ', label: 'Iraq', dial: '964', currency: 'IQD' },
  { code: 'IE', label: 'Ireland', dial: '353', currency: 'EUR' },
  { code: 'IL', label: 'Israel', dial: '972', currency: 'ILS' },
  { code: 'IT', label: 'Italy', dial: '39', currency: 'EUR' },
  { code: 'JM', label: 'Jamaica', dial: '1', currency: 'JMD' },
  { code: 'JP', label: 'Japan', dial: '81', currency: 'JPY' },
  { code: 'JO', label: 'Jordan', dial: '962', currency: 'JOD' },
  { code: 'KZ', label: 'Kazakhstan', dial: '7', currency: 'KZT' },
  { code: 'KE', label: 'Kenya', dial: '254', currency: 'KES' },
  { code: 'KI', label: 'Kiribati', dial: '686', currency: 'AUD' },
  { code: 'KW', label: 'Kuwait', dial: '965', currency: 'KWD' },
  { code: 'KG', label: 'Kyrgyzstan', dial: '996', currency: 'KGS' },
  { code: 'LA', label: 'Laos', dial: '856', currency: 'LAK' },
  { code: 'LV', label: 'Latvia', dial: '371', currency: 'EUR' },
  { code: 'LB', label: 'Lebanon', dial: '961', currency: 'LBP' },
  { code: 'LS', label: 'Lesotho', dial: '266', currency: 'LSL' },
  { code: 'LR', label: 'Liberia', dial: '231', currency: 'LRD' },
  { code: 'LY', label: 'Libya', dial: '218', currency: 'LYD' },
  { code: 'LI', label: 'Liechtenstein', dial: '423', currency: 'CHF' },
  { code: 'LT', label: 'Lithuania', dial: '370', currency: 'EUR' },
  { code: 'LU', label: 'Luxembourg', dial: '352', currency: 'EUR' },
  { code: 'MO', label: 'Macau', dial: '853', currency: 'MOP' },
  { code: 'MG', label: 'Madagascar', dial: '261', currency: 'MGA' },
  { code: 'MW', label: 'Malawi', dial: '265', currency: 'MWK' },
  { code: 'MY', label: 'Malaysia', dial: '60', currency: 'MYR' },
  { code: 'MV', label: 'Maldives', dial: '960', currency: 'MVR' },
  { code: 'ML', label: 'Mali', dial: '223', currency: 'XOF' },
  { code: 'MT', label: 'Malta', dial: '356', currency: 'EUR' },
  { code: 'MH', label: 'Marshall Islands', dial: '692', currency: 'USD' },
  { code: 'MQ', label: 'Martinique', dial: '596', currency: 'EUR' },
  { code: 'MR', label: 'Mauritania', dial: '222', currency: 'MRU' },
  { code: 'MU', label: 'Mauritius', dial: '230', currency: 'MUR' },
  { code: 'MX', label: 'Mexico', dial: '52', currency: 'MXN' },
  { code: 'FM', label: 'Micronesia', dial: '691', currency: 'USD' },
  { code: 'MD', label: 'Moldova', dial: '373', currency: 'MDL' },
  { code: 'MC', label: 'Monaco', dial: '377', currency: 'EUR' },
  { code: 'MN', label: 'Mongolia', dial: '976', currency: 'MNT' },
  { code: 'ME', label: 'Montenegro', dial: '382', currency: 'EUR' },
  { code: 'MS', label: 'Montserrat', dial: '1', currency: 'XCD' },
  { code: 'MA', label: 'Morocco', dial: '212', currency: 'MAD' },
  { code: 'MZ', label: 'Mozambique', dial: '258', currency: 'MZN' },
  { code: 'MM', label: 'Myanmar', dial: '95', currency: 'MMK' },
  { code: 'NA', label: 'Namibia', dial: '264', currency: 'NAD' },
  { code: 'NR', label: 'Nauru', dial: '674', currency: 'AUD' },
  { code: 'NP', label: 'Nepal', dial: '977', currency: 'NPR' },
  { code: 'NL', label: 'Netherlands', dial: '31', currency: 'EUR' },
  { code: 'NC', label: 'New Caledonia', dial: '687', currency: 'XPF' },
  { code: 'NZ', label: 'New Zealand', dial: '64', currency: 'NZD' },
  { code: 'NI', label: 'Nicaragua', dial: '505', currency: 'NIO' },
  { code: 'NE', label: 'Niger', dial: '227', currency: 'XOF' },
  { code: 'NG', label: 'Nigeria', dial: '234', currency: 'NGN' },
  { code: 'NU', label: 'Niue', dial: '683', currency: 'NZD' },
  { code: 'KP', label: 'North Korea', dial: '850', currency: 'KPW' },
  { code: 'MK', label: 'North Macedonia', dial: '389', currency: 'MKD' },
  { code: 'MP', label: 'Northern Mariana Islands', dial: '1', currency: 'USD' },
  { code: 'NO', label: 'Norway', dial: '47', currency: 'NOK' },
  { code: 'OM', label: 'Oman', dial: '968', currency: 'OMR' },
  { code: 'PK', label: 'Pakistan', dial: '92', currency: 'PKR' },
  { code: 'PW', label: 'Palau', dial: '680', currency: 'USD' },
  { code: 'PS', label: 'Palestine', dial: '970', currency: 'ILS' },
  { code: 'PA', label: 'Panama', dial: '507', currency: 'PAB' },
  { code: 'PG', label: 'Papua New Guinea', dial: '675', currency: 'PGK' },
  { code: 'PY', label: 'Paraguay', dial: '595', currency: 'PYG' },
  { code: 'PE', label: 'Peru', dial: '51', currency: 'PEN' },
  { code: 'PH', label: 'Philippines', dial: '63', currency: 'PHP' },
  { code: 'PL', label: 'Poland', dial: '48', currency: 'PLN' },
  { code: 'PT', label: 'Portugal', dial: '351', currency: 'EUR' },
  { code: 'PR', label: 'Puerto Rico', dial: '1', currency: 'USD' },
  { code: 'QA', label: 'Qatar', dial: '974', currency: 'QAR' },
  { code: 'RE', label: 'Réunion', dial: '262', currency: 'EUR' },
  { code: 'RO', label: 'Romania', dial: '40', currency: 'RON' },
  { code: 'RU', label: 'Russia', dial: '7', currency: 'RUB' },
  { code: 'RW', label: 'Rwanda', dial: '250', currency: 'RWF' },
  { code: 'KN', label: 'Saint Kitts and Nevis', dial: '1', currency: 'XCD' },
  { code: 'LC', label: 'Saint Lucia', dial: '1', currency: 'XCD' },
  { code: 'VC', label: 'Saint Vincent and the Grenadines', dial: '1', currency: 'XCD' },
  { code: 'WS', label: 'Samoa', dial: '685', currency: 'WST' },
  { code: 'SM', label: 'San Marino', dial: '378', currency: 'EUR' },
  { code: 'ST', label: 'São Tomé and Príncipe', dial: '239', currency: 'STN' },
  { code: 'SA', label: 'Saudi Arabia', dial: '966', currency: 'SAR' },
  { code: 'SN', label: 'Senegal', dial: '221', currency: 'XOF' },
  { code: 'RS', label: 'Serbia', dial: '381', currency: 'RSD' },
  { code: 'SC', label: 'Seychelles', dial: '248', currency: 'SCR' },
  { code: 'SL', label: 'Sierra Leone', dial: '232', currency: 'SLE' },
  { code: 'SG', label: 'Singapore', dial: '65', currency: 'SGD' },
  { code: 'SK', label: 'Slovakia', dial: '421', currency: 'EUR' },
  { code: 'SI', label: 'Slovenia', dial: '386', currency: 'EUR' },
  { code: 'SB', label: 'Solomon Islands', dial: '677', currency: 'SBD' },
  { code: 'SO', label: 'Somalia', dial: '252', currency: 'SOS' },
  { code: 'ZA', label: 'South Africa', dial: '27', currency: 'ZAR' },
  { code: 'KR', label: 'South Korea', dial: '82', currency: 'KRW' },
  { code: 'SS', label: 'South Sudan', dial: '211', currency: 'SSP' },
  { code: 'ES', label: 'Spain', dial: '34', currency: 'EUR' },
  { code: 'LK', label: 'Sri Lanka', dial: '94', currency: 'LKR' },
  { code: 'SD', label: 'Sudan', dial: '249', currency: 'SDG' },
  { code: 'SR', label: 'Suriname', dial: '597', currency: 'SRD' },
  { code: 'SE', label: 'Sweden', dial: '46', currency: 'SEK' },
  { code: 'CH', label: 'Switzerland', dial: '41', currency: 'CHF' },
  { code: 'SY', label: 'Syria', dial: '963', currency: 'SYP' },
  { code: 'TW', label: 'Taiwan', dial: '886', currency: 'TWD' },
  { code: 'TJ', label: 'Tajikistan', dial: '992', currency: 'TJS' },
  { code: 'TZ', label: 'Tanzania', dial: '255', currency: 'TZS' },
  { code: 'TH', label: 'Thailand', dial: '66', currency: 'THB' },
  { code: 'TL', label: 'Timor-Leste', dial: '670', currency: 'USD' },
  { code: 'TG', label: 'Togo', dial: '228', currency: 'XOF' },
  { code: 'TO', label: 'Tonga', dial: '676', currency: 'TOP' },
  { code: 'TT', label: 'Trinidad and Tobago', dial: '1', currency: 'TTD' },
  { code: 'TN', label: 'Tunisia', dial: '216', currency: 'TND' },
  { code: 'TR', label: 'Turkey', dial: '90', currency: 'TRY' },
  { code: 'TM', label: 'Turkmenistan', dial: '993', currency: 'TMT' },
  { code: 'TC', label: 'Turks and Caicos Islands', dial: '1', currency: 'USD' },
  { code: 'TV', label: 'Tuvalu', dial: '688', currency: 'AUD' },
  { code: 'UG', label: 'Uganda', dial: '256', currency: 'UGX' },
  { code: 'UA', label: 'Ukraine', dial: '380', currency: 'UAH' },
  { code: 'AE', label: 'United Arab Emirates', dial: '971', currency: 'AED' },
  { code: 'GB', label: 'United Kingdom', dial: '44', currency: 'GBP' },
  { code: 'US', label: 'United States', dial: '1', currency: 'USD' },
  { code: 'UY', label: 'Uruguay', dial: '598', currency: 'UYU' },
  { code: 'UZ', label: 'Uzbekistan', dial: '998', currency: 'UZS' },
  { code: 'VU', label: 'Vanuatu', dial: '678', currency: 'VUV' },
  { code: 'VA', label: 'Vatican City', dial: '39', currency: 'EUR' },
  { code: 'VE', label: 'Venezuela', dial: '58', currency: 'VES' },
  { code: 'VN', label: 'Vietnam', dial: '84', currency: 'VND' },
  { code: 'VI', label: 'Virgin Islands (US)', dial: '1', currency: 'USD' },
  { code: 'YE', label: 'Yemen', dial: '967', currency: 'YER' },
  { code: 'ZM', label: 'Zambia', dial: '260', currency: 'ZMW' },
  { code: 'ZW', label: 'Zimbabwe', dial: '263', currency: 'ZWL' },
];

export const findCountry = (code) => COUNTRIES.find((c) => c.code === code) || null;

export const getCurrencyForCountry = (code) => {
  const c = findCountry(code);
  return c?.currency || 'USD';
};
